import { render, staticRenderFns } from "./WeirChartComponent.vue?vue&type=template&id=1f7ef4bc&scoped=true&"
import script from "./WeirChartComponent.vue?vue&type=script&lang=js&"
export * from "./WeirChartComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7ef4bc",
  null
  
)

export default component.exports